/**
 * @generated SignedSource<<991301e4ae06f83b6b953ffeb227d1f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavHeader_query$data = {
  readonly jira: {
    readonly jiraBoard?: {
      readonly __typename: "JiraBoard";
      readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_board" | "UserBoardHeader_board">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_query">;
  readonly " $fragmentType": "NavHeader_query";
};
export type NavHeader_query$key = {
  readonly " $data"?: NavHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "boardId"
    },
    {
      "kind": "RootArgument",
      "name": "withBoard"
    }
  ],
  "kind": "Fragment",
  "name": "NavHeader_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProjectHeader_query"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "withBoard",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "UserBoardHeader_board"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "HorizontalNavBoardHeader_board"
                      }
                    ],
                    "type": "JiraBoard"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "40f4384a6241e1becab27e3bdaca23ec";

export default node;
